import React, { useState } from "react";
import { Table, Tooltip } from "antd";
import { Resizable } from "react-resizable";
import axios from "axios";
import lib from "./lib";
import md5 from "md5";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { generateUUID } from "../component/form-editor/utils";

function getDisplayName(component) {
    return component.displayName || component.name || "Component";
}

const HOC = {
    mapAuthButtonsToState:
        ({ systemCode: code, pagePath: path, buttonCodeArr: buttonCodeArr } = {}) =>
        WrappedComponent => {
            return class extends WrappedComponent {
                static displayName = `HOC(${getDisplayName(WrappedComponent)})`;

                async componentDidMount() {
                    super.componentDidMount && super.componentDidMount();
                    const systemCode = code || lib.config.systemCode;
                    const pagePath = path || window.location.pathname.replace(/^\/[^\/]+\//, "/");
                    const data = { systemCode, pagePath };
                    try {
                        const res = await lib.request({
                            url: "/ucenter-account/current/lastButtonList",
                            data,
                        });
                        if (res && Array.isArray(res)) {
                            let buttons = res.map(i => i.code);
                            let buttonAuth = {};
                            if (Array.isArray(buttonCodeArr)) {
                                buttonCodeArr.map(item => {
                                    buttonAuth[item] = buttons.includes(item);
                                });
                            }
                            this.setState({
                                buttonAuth,
                                buttons: buttons,
                            });
                        }
                    } catch (error) {
                        this.setState({
                            buttons: [],
                        });
                    }
                }

                render() {
                    return super.render();
                }
            };
        },
    getMariaConfigByDataId: data => WrappedComponent => {
        if (data == null) return WrappedComponent;
        let dataId;
        if (Object.prototype.toString.call(data) === "[object Object]") {
            dataId = Object.values(data)[0];
        } else {
            dataId = data;
        }

        const getDataUrlByDataId = dataId => {
            let mariaUrl = lib.config.mariaUrl || "https://maria-test.yang800.com.cn";
            let config = lib.config.configList.find(item => {
                return item.id === dataId;
            });
            if (config) {
                return `${mariaUrl}/api/data/v2/${dataId}/${config.versionId}`;
            } else {
                return `${mariaUrl}/api/data/v2/${dataId}`;
            }
        };
        const getMariaData = dataId => {
            return axios.get(getDataUrlByDataId(dataId)).then(res => res.data.data);
        };
        return class extends WrappedComponent {
            static displayName = `HOC(${getDisplayName(WrappedComponent)})`;

            componentDidMount() {
                super.componentDidMount && super.componentDidMount();
                Promise.resolve(getMariaData(dataId))
                    .then(config => {
                        config.tableFieldListVersion = md5(JSON.stringify(config.tableFieldList));
                        let storage = localStorage[config.id];
                        if (storage) {
                            storage = JSON.parse(storage);
                            if (storage.tableFieldListVersion == config.tableFieldListVersion) {
                                config.tableFieldList = storage.tableFieldList;
                            } else {
                                // 待优化部分，页面字段变动引起的tableFieldListVersion缓存不一致情况
                            }
                        }
                        return config;
                    })
                    .then(config => {
                        config &&
                            this.setState({ config }, () => {
                                this.setConfigSuccess && this.setConfigSuccess();
                            });
                    })
                    .catch(e => this.setState({ config: "出错了" }));
            }

            loadConfig() {}

            render() {
                return super.render();
            }
        };
    },
    widthSearchListRowSpanAble:
        (rowspanKey, rowspanArray = [], rowKey = "id") =>
        WrappedComponent => {
            if (rowspanKey == null) {
                return WrappedComponent;
            }
            const ResizableTitle = props => {
                const { onResize, ...restProps } = props;
                let [width, setWidth] = useState(props.width);
                let [resizing, setResizing] = useState(false);
                if (!width) {
                    return <th {...restProps} />;
                }
                let thStyle = { ...restProps.style },
                    handleStyle = {};
                if (resizing) {
                    handleStyle = { left: `${width - 11}px` };
                    thStyle.zIndex = 10;
                }
                return (
                    <Resizable
                        width={width}
                        height={0}
                        handle={
                            <div
                                className={`resizable-handle ${resizing && "resizing"}`}
                                onClick={e => {
                                    e.stopPropagation();
                                }}
                                style={handleStyle}></div>
                        }
                        onResizeStart={() => setResizing(true)}
                        onResize={(e, { size }) => {
                            if (size.width > 80 && size.width < 800) {
                                setWidth(size.width);
                            }
                        }}
                        onResizeStop={(e, p) => {
                            setResizing(false);
                            onResize(e, p);
                        }}
                        draggableOpts={{ enableUserSelectHack: false }}>
                        <th {...restProps} style={thStyle}>
                            <div className="title">{restProps.children}</div>
                        </th>
                    </Resizable>
                );
            };
            return class extends WrappedComponent {
                renderTable() {
                    let { config, dataList: _dataList, table, selectedIdList, sorter } = this.state;
                    const dataList = [];
                    let maxWidth = 0;
                    let list = config.tableFieldList
                        .filter(item => item.fixed != "hide")
                        .sort((a, b) => {
                            var type = ["left", "show", "right"];
                            return type.indexOf(a.fixed) - type.indexOf(b.fixed);
                        });
                    let columns = list.map(item => {
                        let fixed = item.fixed;
                        if (["left", "right"].indexOf(item.fixed) === -1) {
                            fixed = undefined;
                        }
                        var column = {
                            title: item.tooltip ? (
                                <Tooltip placement="topLeft" title={item.tooltip} arrowPointAtCenter>
                                    {item.title} <QuestionCircleOutlined />
                                </Tooltip>
                            ) : (
                                item.title
                            ),
                            dataIndex: item.key,
                            width: item.width,
                            ellipsis: { showTitle: false },
                            fixed: fixed,
                            sorter: item.sorter,
                            sortOrder: sorter.field == item.key && sorter.order,
                            onHeaderCell: column => {
                                return {
                                    width: column.width,
                                    onResize: (e, { size }) => {
                                        item.width = size.width;
                                        this.setState({ config });
                                    },
                                };
                            },
                            render: (text, row, index) => {
                                const children =
                                    item.type == "function" || item.type == "js"
                                        ? item.type == "js"
                                            ? eval(item.key)
                                            : this[item.key](row, index)
                                        : text;
                                if (row.len > 0 && !rowspanArray.includes(item.key)) {
                                    if (row.index === 0) {
                                        return {
                                            children,
                                            props: {
                                                rowSpan: row.len,
                                            },
                                        };
                                    } else {
                                        return {
                                            children,
                                            props: {
                                                rowSpan: 0,
                                            },
                                        };
                                    }
                                } else {
                                    return {
                                        children,
                                    };
                                }
                            },
                        };
                        maxWidth += column.width;
                        return column;
                    });
                    let rowSelection = config.page.isBatch && {
                        onChange: (selectedIdList, selectedRows) => {
                            this.setState({
                                selectedIdList,
                                selectedRows,
                            });
                        },
                        fixed: true,
                        preserveSelectedRowKeys: true,
                        selectedRowKeys: selectedIdList,
                        getCheckboxProps: this.getCheckboxProps,
                        renderCell(checked, record, index, originNode) {
                            const leng = record?.[rowspanKey]?.length;
                            if (leng > 0 && record.index === 0) {
                                return {
                                    children: originNode,
                                    props: {
                                        rowSpan: leng,
                                    },
                                };
                            } else {
                                return {
                                    children: originNode,
                                    props: {
                                        rowSpan: 0,
                                    },
                                };
                            }
                        },
                    };
                    let expandable = !this.renderExpandRow
                        ? null
                        : {
                              rowExpandable: row => this.renderExpandRow(row, false) != null,
                              expandedRowRender: (row, _, __, expanded) => this.renderExpandRow(row, expanded),
                          };
                    _dataList.map((item, index) => {
                        const length = item[rowspanKey]?.length;
                        let rowKeyValue = item[rowKey] || index;
                        if (length) {
                            item[rowspanKey]?.map((i, inde) => {
                                const subitem = {
                                    ...item,
                                    len: length,
                                    index: inde,
                                    _index: `${rowKeyValue}-${inde}`,
                                    ...i,
                                };
                                dataList.push(subitem);
                            });
                        } else {
                            item._index = `${rowKeyValue}-${0}`;
                            dataList.push(item);
                        }
                    });

                    return (
                        <div className="search-list-table">
                            <Table
                                rowSelection={rowSelection}
                                rowKey={"_index"}
                                size="small"
                                bordered={config.page.bordered}
                                pagination={false}
                                expandable={expandable}
                                components={{ header: { cell: ResizableTitle } }}
                                dataSource={dataList}
                                columns={columns}
                                onChange={this.handleTableChange}
                                scroll={{ x: maxWidth, y: table.height }}></Table>
                        </div>
                    );
                }
            };
        },
};

export default HOC;
